window.hoculus = window.hoculus || {};

hoculus.utils = class {
	static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static stripGID(gid) {
		return gid.split('/').at(-1);
	}

	static async storefrontRequest(query, apiVersion = '2026-04') {
		const response = await fetch(`https://${Shopify.shop}/api/${apiVersion}/graphql.json`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(query)
		});

		if (!response.ok) {
			throw new Error('Network error');
		}

		const data = await response.json();

		return data;
	}
}

hoculus.waitForElement = function(selector) {
	return new Promise(resolve => {
		const element = document.querySelector(selector);
        element && resolve(element);

		const observer = new MutationObserver(() => {
			const element = document.querySelector(selector);
			if (element) {
				observer.disconnect();
				resolve(element);
			}
		});
        
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});

	});
};

hoculus.Gorgias = async function() {
	const footer = document.querySelector(".footer");
	const gorgiasWidget = await hoculus.waitForElement("#gorgias-chat-container iframe#chat-button");

	if (!window.hoculus.settings?.scroll?.hideWidgetsOnFooter || !footer || !gorgiasWidget) return;

	const observer = new IntersectionObserver(([entry]) => {
		gorgiasWidget.style.transform = entry.isIntersecting
			? "translateX(150%)"
			: "translateX(0)";
	}, { threshold: 0.1 });

	observer.observe(footer);
};

hoculus.utils.domreadyState().then(async () => {
	hoculus.Gorgias();
});